import React from 'react';
import { Fragment } from 'react';
import Header from '../../components/header'
import Footer from '../../components/footer';
import Perguntas from '../../components/perguntas';
import Head from '../../components/head';


function PerguntasScreen () {
    return (
        <Fragment>
            <Head titulo="Perguntas Frequentes - Portal da Transparência da Prefeitura de Macuco" />
            <Header />
            <Perguntas />
            <Footer />
        </Fragment>
    );
}

export default PerguntasScreen;